import WidgetInput from './WidgetInput';
import PropsNumber from './interfaces/PropsNumberInterface';

export default class WidgetNumber extends WidgetInput<PropsNumber> {}
